
import { supabase } from "@/integrations/supabase/client";

interface InventoryTrackingData {
  inventoryItemId: string;
  storeId: string;
  previousQuantity?: number;
  currentQuantity: number;
  minimumQuantity: number;
  itemName: string;
  unitOfMeasure?: string;
}

export const trackInventoryChange = async (data: InventoryTrackingData) => {
  try {
    console.log("Tracking inventory change:", data);
    
    const { data: response, error } = await supabase.functions.invoke(
      "inventory-tracker",
      {
        body: data
      }
    );

    if (error) {
      console.error("Error calling inventory tracker:", error);
      throw error;
    }

    console.log("Inventory tracking response:", response);
    return response;
  } catch (error) {
    console.error("Error in trackInventoryChange:", error);
    throw error;
  }
};

export const trackInventoryUpdate = async (
  inventoryItemId: string,
  storeId: string,
  itemName: string,
  previousQuantity: number,
  newQuantity: number,
  minimumQuantity: number,
  unitOfMeasure?: string
) => {
  return trackInventoryChange({
    inventoryItemId,
    storeId,
    previousQuantity,
    currentQuantity: newQuantity,
    minimumQuantity,
    itemName,
    unitOfMeasure
  });
};
